import { editSectionAsync } from "components/features/MyPlanDetails/MyPlanDetails.slice";
import * as React from "react";
import { useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { checkTemplatePlanPayload } from "utils/StoreUtils";
import SectionFormContent from "./SectionFormContent";

type Inputs = {
  Title: string;
  Description: string;
};
interface Props {
  item: any;
  handleDialogClose: () => void;
}

function EditSectionForm(props: Props, ref: any) {
  const { item, handleDialogClose } = props;
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<Inputs>();

  const [sectionTitleValue, setSectionTitleValue] = React.useState(item.Title);
  const [sectionDescriptionValue, setSectionDescriptionValue] = React.useState(item.Description);
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const dispatch = useAppDispatch();

  React.useImperativeHandle(ref, () => {
    return {
      submitForm: () => {
        const onsubmit = handleSubmit((data) => {
          handleDialogClose();
          const payload = {
            planId: selectedMyPlanDetail?.id,
            sectionId: item.SectionId,
            name: sectionTitleValue,
            summary: sectionDescriptionValue
          };
          const props = checkTemplatePlanPayload(payload);
          dispatch(editSectionAsync(props));
        });
        onsubmit();
      }
    };
  });

  return (
    <SectionFormContent
      setSectionTitleValue={setSectionTitleValue}
      setSectionDescriptionValue={setSectionDescriptionValue}
      item={item}
      register={register}
      errors={errors}
    />
  );
}

export default React.forwardRef(EditSectionForm);
